<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div>
					<div v-if="i === 'contributors'">
						<h5>Contributors</h5>
						<Repeater
							v-if="getContentTemplate"
							:itemArray="componentItem.content"
							:itemField="i"
							:template="getContentTemplate.content.contributors[0]"
						/>
					</div>
					<div v-else-if="typeof content !== 'object'" class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import Repeater from '../Repeater';

	export default {

		components: {
			Repeater,
		},

		name: 'Credits',
		
		props: ['componentItem', 'index', 'componentTemplates'],

		computed:{
			getContentTemplate() {
				if(this.componentTemplates){
					return JSON.parse(JSON.stringify(
						this.componentTemplates.filter(item => item.template == 'credits')[0]
					));
				}else{
					return null
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}

</style>